import { useParams } from 'next/navigation'

export default function useGetToolId() {
  const params = useParams<{ toolCode: string }>()
  return { toolCode: params?.toolCode || '' }
}
